/**
 * Сравнивает два значения sortOrder по правилам:
 * - Отрицательные идут ПОСЛЕ положительных.
 * - Внутри отрицательных: -1 выше -2 → -1 должен быть раньше.
 */
const compareBySortOrder = (a, b) => {
  const aOrder = a.sortOrder;
  const bOrder = b.sortOrder;

  const aNeg = aOrder < 0;
  const bNeg = bOrder < 0;

  if (aNeg && bNeg) {
    return bOrder - aOrder; // -1 перед -2
  }

  if (aNeg !== bNeg) {
    return aNeg ? 1 : -1; // отрицательные идут после положительных
  }

  return aOrder - bOrder; // обычная числовая сортировка
};

/**
 * Сравнивает два значения по правилам:
 * - Отрицательные идут ПОСЛЕ положительных.
 * - Внутри отрицательных: -1 выше -2 → -1 должен быть раньше.
 */
const compareByFloors = (a, b) => {
  const aNum = Number(a);
  const bNum = Number(b);

  const aNeg = aNum < 0;
  const bNeg = bNum < 0;

  if (aNeg && bNeg) {
    return bNum - aNum; // -1 перед -2
  }

  if (aNeg !== bNeg) {
    return aNeg ? 1 : -1; // отрицательные идут после положительных
  }

  return aNum - bNum; // обычная числовая сортировка
};

/**
 * Сравнивает два значения flat по правилам:
 * - Если один начинается с буквы, а другой с цифры — буква выше.
 * - Иначе используем локализованное сравнение с numeric.
 */
export const compareByFlat = (a, b) => {
  const aVal = a.flat;
  const bVal = b.flat;

  const aLetter = /^\D/.test(aVal);
  const bLetter = /^\D/.test(bVal);

  if (aLetter !== bLetter) {
    return aLetter ? -1 : 1; // буква → выше
  }

  return aVal.localeCompare(bVal, undefined, { numeric: true });
};

export const sortingStrategies = {
  bySortOrder: compareBySortOrder,
  byFloors: compareByFloors,
  byFlat: compareByFlat,
};
